/**
 * Analytics Module - Segment Events, Tracking, and Cookies
 *
 * This module combines segment events, generic tracking functionality,
 * and UTM cookie management into a unified analytics system.
 */

import DatadogRUM from './datadog.js';
import FreshpaintAnalytics from './freshpaint.js';
import GTMAnalytics from './gtm.js';
import IntercomAnalytics from './intercom.js';
import SegmentAnalytics from './segment.js';
import GenericTracking from './tracking.js';
import TrustpilotAnalytics from './trustpilot.js';
import UTMCookiesManager from './utm-cookies.js';

/**
 * Initialize Segment Analytics
 * Must be before generic tracking
 * Fullstory is loaded through segment
 *
 * @return {void}
 */
function initializeSegmentAnalytics() {
	new SegmentAnalytics();
}

/**
 * Initialize Scripts
 *
 * @return {void}
 */
function initializeScripts() {
	new DatadogRUM();
	// GA4 is loaded through freshpaint
	new FreshpaintAnalytics();
	new GTMAnalytics();
	new IntercomAnalytics();
	new TrustpilotAnalytics();
	new UTMCookiesManager();

	const genericTracking = new GenericTracking();
	window.GenericTracking = genericTracking;
}

initializeSegmentAnalytics();

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => initializeScripts());
} else {
	initializeScripts();
}
